import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgIcTemplate = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 28,
	height: 29,
	viewBox: "0 0 28 29",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M9 7.5C9 6.39543 9.89543 5.5 11 5.5H20.608C21.7126 5.5 22.608 6.39543 22.608 7.5V20.132C22.608 21.2366 21.7126 22.132 20.608 22.132H11C9.89543 22.132 9 21.2366 9 20.132V7.5Z",
			fill: "#A7C4FC"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M6.51208 10.5C6.51208 9.39543 7.40752 8.5 8.51208 8.5H18.1201C19.2247 8.5 20.1201 9.39543 20.1201 10.5V23.132C20.1201 24.2366 19.2247 25.132 18.1201 25.132H8.51208C7.40752 25.132 6.51208 24.2366 6.51208 23.132V10.5Z",
			fill: "#6C9CFA"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M9 12.5H17.5",
			stroke: "white",
			strokeWidth: .6
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M9 14.5H15",
			stroke: "white",
			strokeWidth: .6
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M9 16.5H15",
			stroke: "white",
			strokeWidth: .6
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M17.096 22.1079H5C5 23.9223 5.378 24.7539 6.512 25.1319H18.608C18.608 25.1319 17.096 24.3759 17.096 22.1079Z",
			fill: "#8C81F7"
		})
	]
});
export default SvgIcTemplate;
